<div class="app-shell">
  <cf-site-header />
  <cf-breadcrumbs />
  <main class="app-main">
    <router-outlet />
  </main>
  <cf-site-footer />
</div>
